<template>

        <div class="loggin-heading d-flex">
            <svg width="437" height="112" viewBox="0 0 437 112" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.2028 90.3033H71.8151V110.504H0V1.57114H26.2028V90.3033Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M173.189 58.2819C173.189 68.9058 171.223 78.3077 167.292 86.4876C163.36 94.6676 157.761 100.977 150.495 105.416C143.279 109.805 135.042 112 125.785 112C116.529 112 108.317 109.88 101.15 105.641C93.9837 101.351 88.3848 95.2411 84.3536 87.3106C80.3722 79.3801 78.2819 70.2774 78.0828 60.0027V53.8677C78.0828 43.1939 80.0238 33.792 83.9057 25.662C87.8374 17.4821 93.4362 11.1726 100.702 6.73347C108.018 2.29437 116.329 0.0748163 125.636 0.0748163C134.843 0.0748163 143.055 2.26943 150.271 6.65865C157.488 11.0479 163.086 17.3075 167.068 25.4375C171.099 33.5177 173.14 42.7949 173.189 53.2692V58.2819ZM146.539 53.7181C146.539 42.8947 144.722 34.6898 141.089 29.1035C137.506 23.4674 132.355 20.6493 125.636 20.6493C112.497 20.6493 105.555 30.525 104.808 50.2766L104.734 58.2819C104.734 68.9557 106.5 77.1605 110.034 82.8965C113.567 88.6324 118.818 91.5003 125.785 91.5003C132.405 91.5003 137.506 88.6823 141.089 83.0461C144.672 77.4099 146.489 69.3048 146.539 58.7308V53.7181Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M278.744 97.0367C274.713 101.526 268.815 105.142 261.052 107.885C253.288 110.628 244.777 112 235.521 112C221.287 112 209.915 107.636 201.405 98.9071C192.894 90.1786 188.341 78.0334 187.743 62.4716L187.669 53.0448C187.669 42.3211 189.56 32.969 193.342 24.9886C197.125 16.9584 202.525 10.7985 209.542 6.50902C216.609 2.16967 224.771 0 234.028 0C247.564 0 258.065 3.11735 265.531 9.35204C273.046 15.5369 277.425 24.7891 278.669 37.1089H253.437C252.541 31.0238 250.6 26.6845 247.614 24.0908C244.628 21.4972 240.398 20.2004 234.923 20.2004C228.354 20.2004 223.278 22.9935 219.694 28.5798C216.111 34.1661 214.295 42.1465 214.245 52.521V59.1049C214.245 69.9782 216.086 78.1581 219.769 83.6446C223.502 89.0813 229.349 91.7996 237.312 91.7996C244.13 91.7996 249.207 90.2783 252.541 87.2358V70.3273H234.326V52.2966H278.744V97.0367Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M324.951 110.504H298.822V1.57114H324.951V110.504Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M437 110.504H410.947L372.426 42.7201V110.504H346.223V1.57114H372.426L410.872 69.3547V1.57114H437V110.504Z" fill="#F0F5FD" fill-opacity="0.1"/>
            </svg>
        </div>

</template>

<script>
// import BlackList from "../BlackList/BlackList";
export default {
    name: "LoginHeading",
    // components: {
    //   BlackList
    // },
    data(){
        return{}
    }
}
</script>

<style lang="scss" scoped>
.loggin-heading{
    background: radial-gradient(100% 2844.44% at 0% 50%, #2E76E4 0%, #6C4DBB 100%);
    justify-content: center;
}

@media screen and (max-width: 768px){
    .loggin-heading{
        padding: 10px;
    }
    .loggin-heading svg{
        width: 100%;
        max-width: 300px;
        height: auto;
    }
}
</style>
